import styled from 'styled-components';

import {
  Grid as SemanticGrid,
  Divider as SemanticDivider,
  Icon as SemanticIcon,
  Image as SemanticImage,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent, colors } from '@playbookux/playbook-web-core';

const { SHOW_SELECTED, HOVER_LINK, LINK_COLOR } = colors;

const fontSize = '14px';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 30px 10px;
  padding-bottom: ${(props) => (props.compact && fontSize)};
  padding-left: ${(props) => (props.compact && '0')};
`;

const Title = styled(TextLayoutComponent.Bold)`
  font-size: 18px;
  margin: 20px 20px 0 20px;
  text-align: left;
`;

const Divider = styled(SemanticDivider)`
  &&&& {
    border-top: 2px solid #EDEDED;
    margin: 0 20px 28px 20px;
  }
`;

const Grid = styled(SemanticGrid)`
  &&& {
    padding: 0 10px 0 10px;
    text-align: left;
    margin-top: ${(props) => (props.showTitle ? '20px' : '0')};
  }
`;

const Row = styled(SemanticGrid.Row)`
  &&& {
    margin-bottom: -5px;
    margin-top: -20px;
    text-align: left;
  }
`;

const Column = styled(SemanticGrid.Column)`
  &&& {
    font-size: ${fontSize};
    font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
    margin: 0 10px 0 10px;
    text-align: left;
  }
`;

const ShowProfileLink = styled.a`
  color: ${SHOW_SELECTED};
  :hover {
    color: ${HOVER_LINK};
  }
`;

const ColumnName = styled(TextLayoutComponent.Bold)``;

const ColumnValue = styled(TextLayoutComponent)``;

const Icon = styled(SemanticIcon)`
  &&& {
    color: ${LINK_COLOR};
    cursor: pointer;
  }
`;

const Image = styled(SemanticImage)`
  width: 120px;
`;

const UserInterviewsMessage = styled(TextLayoutComponent.Bold)`
  display: flex;
  margin-top: 15px;
  margin-left: 20px;
  align-items: center;
  gap: 1em;
  line-height: 0;
  text-align: left;
  flex-wrap: wrap;
`;

export {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Divider,
  Grid,
  Row,
  ShowProfileLink,
  Title,
  Icon,
  Image,
  UserInterviewsMessage,
};
